import React from 'react';
import { Form, Alert, Badge } from 'react-bootstrap';

const DatasetViewerFilterPanel = ({
  showFilterPanel,
  filter,
  setFilter,
  setFilterErr,
  setPage,
  computedFilterErr,
  colFilters,
  columns,
  clearColFilter,
  filterActive,
  shown,
  quick
}) => {
  if (!showFilterPanel) return null;

  return (
    <div className="p-2 border-bottom bg-light">
      <div className="d-flex flex-wrap align-items-center gap-2">
        <Form.Label className="fw-semibold m-0">Filter:</Form.Label>
        <Form.Control
          type="text"
          style={{ flex: '1', minWidth: '260px' }}
          placeholder="Type to filter rows..."
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') setPage(1); }}
        />
        <button className="updateProfile" type="button" onClick={() => setPage(1)}>Apply</button>
        <button className="removeProfile" type="button" onClick={() => { setFilter(''); setFilterErr(''); setPage(1); }}>Clear</button>
      </div>
      <div className="text-muted small mt-1">
        {`Operators: == != > < >= <= — combine with and / or. Quote text values. Or use a column's ▾ menu for contains / equals / blank / range filters.`}
      </div>
      {computedFilterErr && <Alert variant="danger" className="mt-1 mb-0 py-1">{computedFilterErr}</Alert>}
      {Object.entries(colFilters).map(([k, f]) => {
        const col = columns[+k];
        return (
          <Badge key={k} bg="success-subtle" className="me-1 mt-1 text-success">
            {col} {f.op === 'blank' || f.op === 'nonblank' ? (f.op === 'blank' ? 'is blank' : 'is not blank') : `${f.op} ${f.val}${(f.op === 'between' && f.val2) ? `..${f.val2}` : ''}`}
            <span className="ms-1 CP" title="Remove Filter" onClick={() => clearColFilter(+k)}>✕</span>
          </Badge>
        );
      })}
      {filterActive && shown === 0 && <Alert variant="warning" className="mt-1 mb-0 py-1">WARNING: filter returned zero records.</Alert>}
    </div>
  );
};

export default DatasetViewerFilterPanel;
